import MarketHandler from './components/MarketHandler';
import { OrderType, TradeType } from '../../typing';
import LimitHandler from './components/LimitHandler';
import { useState } from 'react';
import OrderTypeController from '../OrderTypeController';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@/components/ThemeProvider';
import { cn } from '@/lib/utils';
import { useParams } from 'react-router-dom';
import { Reload } from '@/widget/Icon';
import { useAppStore } from '@/store';
import ChartSheet from '../ChartSheet';

export default () => {
  const { address: tokenAddress } = useParams();
  const [orderType, setOrderType] = useState<OrderType>('market');
  const [tradeType, setTradeType] = useState<TradeType>('buy');

  const { fwClass } = useAppStore();
  const { t } = useTranslation();
  const { theme } = useTheme();

  const activeTradeStyle = 'bg-themeColor text-black h-full flex items-center justify-center';
  return (
    <div>
      <div className="h-[1px] bg-borderColor my-[24px]"></div>
      <div className="flex justify-between mb-[24px]">
        <div
          className={cn(
            'w-[108px] h-[30px] text-[14px] flex items-center rounded-[8px] bg-[#F4F4F5] dark:bg-[#27272A] text-[#71717A] dark:text-[#A1A1AA]',
            fwClass,
          )}
        >
          <div className={cn('rounded-[8px] flex-1 flex justify-center', tradeType == 'buy' && activeTradeStyle)} onClick={() => setTradeType('buy')}>
            {t('Trade.buy')}
          </div>
          <div
            className={cn('rounded-[8px] flex-1 flex justify-center', tradeType == 'sell' && activeTradeStyle)}
            onClick={() => setTradeType('sell')}
          >
            {t('Trade.sell')}
          </div>
        </div>
        {tokenAddress && (
          <div className="flex items-center gap-x-[16px]">
            <Reload theme={theme} className="size-[18px]" onClick={() => window.location.reload()} />
            <ChartSheet />
          </div>
        )}
      </div>
      {orderType == 'market' ? <MarketHandler tradeType={tradeType} /> : <LimitHandler tradeType={tradeType} />}
      <OrderTypeController orderType={orderType} onChangeOrderType={setOrderType} />
    </div>
  );
};
